<p-toast></p-toast>

<p-drawer [(visible)]="visibleDrawerLeft" header="Component Left Drawer">
    <p class="text-surface-600 dark:text-surface-300">This is an overlay drawer built with PrimeNG, triggered from inside your
        component page</p>
    <div class="mt-4 flex flex-col gap-2">
        <p-button label="Trigger Success Toast" severity="success"
            (onClick)="showToast('success')"></p-button>
        <p-button label="Close Drawer" severity="secondary"
            (onClick)="visibleDrawerLeft = false"></p-button>
    </div>
</p-drawer>

<p-drawer [(visible)]="visibleDrawerRight" header="Component Right Drawer" position="right">
    <p class="text-surface-600 dark:text-surface-300">This is a right-aligned drawer component.</p>
</p-drawer>

<div class="p-6 md:p-8 space-y-8 max-w-8xl mx-auto pb-20">

    <div class="mb-8 border-b pb-4 border-surface-200 dark:border-surface-700">
        <h1 class="text-3xl font-bold text-surface-900 dark:text-white mb-2">PrimeNG V21 Component Library</h1>
        <p class="text-surface-500 dark:text-surface-400">Testing all UI elements with Tailwind CSS styling and dynamic
            theming.</p>
    </div>

<section class="space-y-4">
        <h2 class="text-xl font-semibold text-surface-800 dark:text-surface-200">1. Buttons</h2>
        <div class="flex flex-col gap-6 bg-white dark:bg-surface-800 p-6 rounded-xl shadow-sm border border-surface-100 dark:border-surface-700">
            
            <div class="flex flex-wrap items-center gap-4">
                <p-button label="Basic"></p-button>
                <p-button label="With Icon" icon="pi pi-check"></p-button>
                <p-button label="Disabled" [disabled]="true"></p-button>
            </div>

            <div class="flex flex-wrap items-center gap-4">
                <p-button label="Primary"></p-button>
                <p-button label="Secondary" severity="secondary"></p-button>
                <p-button label="Success" severity="success"></p-button>
                <p-button label="Info" severity="info"></p-button>
                <p-button label="Warning" severity="warn"></p-button>
                <p-button label="Help" severity="help"></p-button>
                <p-button label="Danger" severity="danger"></p-button>
            </div>

            <div class="flex flex-wrap items-center gap-4">
                <p-button label="Outlined" [outlined]="true"></p-button>
                <p-button label="Secondary" severity="secondary" [outlined]="true"></p-button>
                <p-button label="Success" severity="success" [outlined]="true"></p-button>
                <p-button icon="pi pi-bookmark" severity="info" [outlined]="true"></p-button>
            </div>

            <div class="flex flex-wrap items-center gap-4">
                <p-button label="Emails" badge="2"></p-button>
                <p-button label="Messages" icon="pi pi-users" severity="warn" badge="8" badgeClass="p-badge-danger"></p-button>
            </div>

            <hr class="border-surface-200 dark:border-surface-700 my-2">

            <div class="flex flex-wrap items-center gap-4">
                <p class="w-full text-sm font-medium text-surface-500 dark:text-surface-400 -mb-2">Common Actions </p>
                
                <p-button icon="pi pi-eye" severity="info" [rounded]="true" pTooltip="View Details" tooltipPosition="top" ariaLabel="View"></p-button>
                
                <p-button icon="pi pi-pencil" severity="success" [rounded]="true" pTooltip="Edit Record" tooltipPosition="top" ariaLabel="Edit"></p-button>
                
                <p-button icon="pi pi-send" severity="help" [rounded]="true" pTooltip="Publish" tooltipPosition="top" ariaLabel="Publish"></p-button>
                
                <p-button icon="pi pi-trash" severity="danger" [rounded]="true" pTooltip="Delete" tooltipPosition="top" ariaLabel="Delete"></p-button>
            </div>

            <div class="flex flex-wrap items-center gap-4">
                <p class="w-full text-sm font-medium text-surface-500 dark:text-surface-400 -mb-2">Common Actions Outlined</p>
                
                <p-button icon="pi pi-eye" severity="info" [rounded]="true" pTooltip="View Details" tooltipPosition="top" ariaLabel="View" [outlined]="true"></p-button>
                
                <p-button icon="pi pi-pencil" severity="success" [rounded]="true" pTooltip="Edit Record" tooltipPosition="top" ariaLabel="Edit" [outlined]="true"></p-button>
                
                <p-button icon="pi pi-send" severity="help" [rounded]="true" pTooltip="Publish" tooltipPosition="top" ariaLabel="Publish" [outlined]="true"></p-button>
                
                <p-button icon="pi pi-trash" severity="danger" [rounded]="true" pTooltip="Delete" tooltipPosition="top" ariaLabel="Delete" [outlined]="true"></p-button>
            </div>

        </div>
    </section>

    

    <section class="space-y-4">
        <h2 class="text-xl font-semibold text-surface-800 dark:text-surface-200">1. Drawers, Dialogs & Overlays</h2>
        <div
            class="flex flex-wrap gap-4 bg-white dark:bg-surface-800 p-6 rounded-xl shadow-sm border border-surface-100 dark:border-surface-700">
            <p-button icon="pi pi-arrow-right" label="Left Drawer" (onClick)="visibleDrawerLeft = true"
            ></p-button>
            <p-button icon="pi pi-arrow-left" label="Right Drawer" severity="secondary"
                (onClick)="visibleDrawerRight = true"></p-button>
            <p-button icon="pi pi-window-maximize" label="Show Dialog" severity="help"
                (onClick)="visibleDialog = true"></p-button>
            <p-button icon="pi pi-search" label="Toggle Popover" severity="info"
                (click)="op.toggle($event)"></p-button>

            <p-dialog header="Sample Modal Dialog" [(visible)]="visibleDialog" [modal]="true"
                [style]="{ width: '25vw' }">
                <p class="text-surface-700 dark:text-surface-300">This is a centered modal dialog. Perfect for confirmations!
                </p>
                <ng-template pTemplate="footer">
                    <p-button label="Close" icon="pi pi-times" (onClick)="visibleDialog = false"></p-button>
                </ng-template>
            </p-dialog>

            <p-popover #op>
                <div class="p-3 w-64">
                    <span class="font-medium text-surface-900 dark:text-white block mb-2">Popover Content</span>
                    <input pInputText placeholder="Search..." class="w-full" />
                </div>
            </p-popover>
        </div>
    </section>

    <section class="space-y-4">
        <h2 class="text-xl font-semibold text-surface-800 dark:text-surface-200 mt-8">2. Form Fields & Inputs</h2>
        <div
            class="grid grid-cols-1 md:grid-cols-2 gap-6 bg-white dark:bg-surface-800 p-6 rounded-xl shadow-sm border border-surface-100 dark:border-surface-700">
            <div class="flex flex-col gap-2">
                <label class="font-medium text-surface-700 dark:text-surface-300">Basic Input Text</label>
                <input pInputText [(ngModel)]="text" placeholder="Type here..." 
                    pTooltip="This is a tooltip!" tooltipPosition="top" tooltipStyleClass="text-xs px-2 py-1" />
            </div>
            <div class="flex flex-col gap-2">
                <label class="font-medium text-surface-700 dark:text-surface-300">Select Dropdown</label>
                <p-select [options]="cities" [(ngModel)]="selectedCity" optionLabel="name" placeholder="Select a City"
                    styleClass="w-full"></p-select>
            </div>
            <div class="flex flex-col gap-2 md:col-span-2">
                <label class="font-medium text-surface-700 dark:text-surface-300">Textarea</label>
                <textarea pTextarea rows="3" placeholder="Enter notes..." ></textarea>
            </div>
            <div class="flex flex-col gap-4 md:col-span-2 border-t pt-4 border-surface-200 dark:border-surface-700">
                <label class="font-medium text-surface-700 dark:text-surface-300">Basic File Upload</label>
                <p-fileupload mode="basic" chooseIcon="pi pi-camera" chooseLabel="Choose Image"
                    accept="image/*"></p-fileupload>
            </div>
        </div>
    </section>

    <section class="space-y-4">
        <h2 class="text-xl font-semibold text-surface-800 dark:text-surface-200 mt-8">3. Data Table</h2>
        <div class="bg-white dark:bg-surface-800 p-6 rounded-xl shadow-sm border border-surface-100 dark:border-surface-700">
            <p-table [value]="products" [tableStyle]="{ 'min-width': '50rem' }">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Code</th>
                        <th>Name</th>
                        <th>Category</th>
                        <th>Quantity</th>
                        <th>Status</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td class="dark:text-surface-300">{{ product.code }}</td>
                        <td class="font-semibold dark:text-white">{{ product.name }}</td>
                        <td class="dark:text-surface-300">{{ product.category }}</td>
                        <td class="dark:text-surface-300">{{ product.quantity }}</td>
                        <td>
                            <p-tag [value]="product.inventoryStatus"
                                [severity]="product.inventoryStatus === 'INSTOCK' ? 'success' : (product.inventoryStatus === 'LOWSTOCK' ? 'warn' : 'danger')">
                            </p-tag>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </section>

    <section class="space-y-4">
        <h2 class="text-xl font-semibold text-surface-800 dark:text-surface-200 mt-8">4. Panels & Accordions</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <p-card header="Profile Card" styleClass="h-full shadow-sm rounded-md">
                <div class="flex items-center gap-4 mb-4">
                    <p-avatar label="DW" size="xlarge" shape="circle" styleClass="bg-emerald-500 text-white"></p-avatar>
                    <div>
                        <h3 class="font-bold text-lg text-surface-900 dark:text-white">Dilshan W.</h3>
                        <p class="text-sm text-surface-500">Software Engineer</p>
                    </div>
                </div>
                <p class="text-surface-600 dark:text-surface-300">Card content goes here. You can use this for dashboards or
                    user profiles.</p>
            </p-card>
            <div
                class="bg-white dark:bg-surface-800 rounded-xl shadow-sm border border-surface-100 dark:border-surface-700 p-2 h-full">
                <p-accordion [value]="['0']">
                    <p-accordion-panel value="0">
                        <p-accordion-header>Project Overview</p-accordion-header>
                        <p-accordion-content>
                            <p class="m-0 text-surface-700 dark:text-surface-300">Details about the Arrow HR platform
                                implementation.</p>
                        </p-accordion-content>
                    </p-accordion-panel>
                    <p-accordion-panel value="1">
                        <p-accordion-header>Timeline</p-accordion-header>
                        <p-accordion-content>
                            <p class="m-0 text-surface-700 dark:text-surface-300">Expected delivery dates and key project
                                milestones.</p>
                        </p-accordion-content>
                    </p-accordion-panel>
                </p-accordion>
            </div>
        </div>
    </section>

    <section class="space-y-4">
        <h2 class="text-xl font-semibold text-surface-800 dark:text-surface-200 mt-8">5. Indicators (Avatars, Badges, Tags)
        </h2>
        <div
            class="flex flex-wrap items-center gap-10 bg-white dark:bg-surface-800 p-6 rounded-xl shadow-sm border border-surface-100 dark:border-surface-700">
            <p-overlayBadge value="2" severity="danger">
                <p-avatar icon="pi pi-user" size="xlarge"></p-avatar>
            </p-overlayBadge>
            <div class="flex gap-3">
                <p-badge value="8" severity="success"></p-badge>
                <p-badge value="New" severity="info"></p-badge>
            </div>
            <div class="flex gap-3 border-l pl-10 border-surface-200 dark:border-surface-700">
                <p-tag value="Primary Layout"></p-tag>
                <p-tag severity="warn" value="Warning" [rounded]="true"></p-tag>
            </div>
        </div>
    </section>

    <!-- ── Record Detail Modal ──────────────────────────────────────────── -->
    <section class="space-y-4">
        <h2 class="text-xl font-semibold text-surface-800 dark:text-surface-200">Record Detail Modal</h2>
        <p class="text-sm text-surface-500 dark:text-surface-400">
            Universal read-only detail modal. Data-driven — pass a <code>RecordDetailConfig</code> to
            <code>UiOrchestratorService.openRecord()</code>.
        </p>
        <div class="flex flex-wrap gap-3 bg-white dark:bg-surface-800 p-6 rounded-xl shadow-sm border border-surface-100 dark:border-surface-700">
            <p-button
                label="Employee Record (tabs)"
                icon="pi pi-user"
                severity="primary"
                (onClick)="openEmployeeDemo()" />
            <p-button
                label="Leave Application (approval actions)"
                icon="pi pi-calendar-times"
                severity="warn"
                [outlined]="true"
                (onClick)="openLeaveDemo()" />
            <p-button
                label="Appraisal (no tabs)"
                icon="pi pi-star"
                severity="info"
                [outlined]="true"
                (onClick)="openAppraisalDemo()" />
        </div>
    </section>

</div>